import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, onMounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'smart_text',
    setup(__props) {
        const isDarkBackground = ref(false);
        const smartText = ref();
        // Function to determine if a colour is dark
        function isColourDark(colour) {
            if (!/^#[0-9A-Fa-f]{6}$/.test(colour)) {
                throw new Error('isColourDark: Invalid colour format. Used hex format pls.');
            }
            const r = parseInt(colour.slice(1, 3), 16);
            const g = parseInt(colour.slice(3, 5), 16);
            const b = parseInt(colour.slice(5, 7), 16);
            const brightness = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
            return brightness <= 0.2; // THIS IS THE THRESHOLD, THIS IS WHAT YOU CHANGE
        }
        // Converts Vues RGB compiled values back in to hex
        function rgbStringToHex(rgb) {
            const regex = /(\d+),\s*(\d+),\s*(\d+)/; // I still don't have a clue how RegEx works :( - https://regex101.com/r/1y0zVy/1
            const match = rgb.match(regex);
            if (!match)
                throw new Error('Invalid RGB format. Use "rgb(r, g, b)".');
            const [, r, g, b] = match.map(Number);
            return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
        }
        onMounted(() => {
            const selector = smartText.value.className.split(' ')[0];
            const parentElements = document.querySelectorAll(`.${selector}`);
            parentElements.forEach(parentElement => {
                // Get the computed background colour of the parent element
                const parentStyle = getComputedStyle(parentElement);
                const parentBackgroundColour = rgbStringToHex(parentStyle.backgroundColor);
                // Determine if the background colour is dark
                isDarkBackground.value = isColourDark(parentBackgroundColour);
                if (!isDarkBackground.value)
                    return;
                const textElements = parentElement.querySelectorAll('p, span, h1, h2, h3, h4, h5, h6, li');
                textElements.forEach(textElement => {
                    const el = textElement;
                    if (isDarkBackground.value)
                        el.style.color = '#fff';
                });
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "smartText",
                ref: smartText
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 512));
        };
    }
});
